export const COMPARE_SLUGS = ['duolingo', 'babbel', 'anki', 'memrise', 'rosetta-stone'] as const;

export type CompareSlugType = (typeof COMPARE_SLUGS)[number];
